import Handlebars from 'handlebars/dist/handlebars.min.js'
window.Handlebars = Handlebars
